import { render, staticRenderFns } from "./AdvancedPixelStreamer.vue?vue&type=template&id=1b1bcbca&"
import script from "./AdvancedPixelStreamer.vue?vue&type=script&lang=js&"
export * from "./AdvancedPixelStreamer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports